import { Injectable, inject } from '@angular/core';
import { AnalyticsService } from './analytics.service';

@Injectable({
  providedIn: 'root'
})
export class CalendlyService {
  private analytics = inject(AnalyticsService);

  async openPopup(url?: string, source?: string) {
    if (typeof window === 'undefined') return;

    // Conversion signal: every Calendly open is a scheduling-intent click.
    // Centralized here so all CTAs (header, hero, side-menu, service pages…)
    // fire the same `schedule_call_click` event into the GTM dataLayer, where
    // it drives both the Google Ads conversion and the GA4 Key Event.
    // `source` identifies which button/page triggered it (segmentation only).
    this.analytics.trackEvent(
      'schedule_call_click',
      source ?? window.location?.pathname ?? 'unknown',
      'conversion'
    );

    // Meta: scheduling intent maps to the standard `Lead` event (dual-path
    // Pixel + Conversions API). The completed-booking `Schedule` event fires
    // later from trackBookingConversion() (popup listener / thank-you page).
    this.analytics.trackLead();

    const target = url ??
      'https://calendly.com/mikekordvani/30min?hide_gdpr_banner=1&background_color=0d0420&text_color=ffffff&primary_color=7c3aed';

    // Navigate to Calendly's full responsive page on every device instead of the
    // popup iframe widget. The popup only partially honors custom theme colors —
    // elements like the "Next" confirm button can fall back to default styling
    // and overlap the themed UI around them — which showed up as broken layout
    // on some screens/zoom levels. Calendly's post-booking redirect lands back
    // on our thank-you page, which is where trackBookingConversion() fires.
    window.location.href = target;
  }
}
